export default function PrivacyPolicy() {
  return (
    <div className="pt-20 px-6 max-w-3xl mx-auto text-white">
      <h1 className="text-3xl font-bold mb-2 tracking-tight">
        Privacy Policy
      </h1>

      <div
        className="h-[2px] w-full rounded-full mb-6"
        style={{ backgroundColor: "#01FFFF" }}
      ></div>

      <p className="text-white/80 mb-6">
        This Privacy Policy describes how CruiseRadar uses cookies and
        third-party technologies in connection with advertising and site
        analytics.
      </p>

      {/* Google Advertising Cookies */}
      <h2 className="text-xl font-semibold mb-2">
        Google Advertising Cookies
      </h2>

      <p className="text-white/80 mb-4">
        Third party vendors, including Google, use cookies to serve ads based
        on a user’s prior visits to this website or other websites.
      </p>

      <p className="text-white/80 mb-4">
        Google’s use of advertising cookies enables it and its partners to
        serve ads to users based on their visit to this site and/or other
        sites on the Internet.
      </p>

      <p className="text-white/80 mb-6">
        Users may opt out of personalized advertising by visiting{" "}
        <a
          href="https://adssettings.google.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-400 underline"
        >
          Google Ads Settings
        </a>
        . Users may also opt out of some third-party vendors’ uses of cookies
        for personalized advertising by visiting{" "}
        <a
          href="https://www.aboutads.info"
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-400 underline"
        >
          www.aboutads.info
        </a>
        .
      </p>

      {/* Third-Party Vendors */}
      <h2 className="text-xl font-semibold mb-2">
        Third-Party Vendors and Ad Networks
      </h2>

      <p className="text-white/80 mb-4">
        If you have not opted out of third-party ad serving, cookies from
        other third-party vendors or ad networks may also be used to serve
        advertisements on this site.
      </p>

      <p className="text-white/80 mb-4">
        These third-party vendors and ad networks may collect information
        about your visits to this and other websites to provide relevant
        advertisements.
      </p>

      <p className="text-white/80 mb-6">
        Users may visit the websites of these vendors or ad networks to learn
        more about their practices and to opt out of personalized advertising
        where available, or alternatively visit{" "}
        <a
          href="https://www.aboutads.info"
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-400 underline"
        >
          www.aboutads.info
        </a>
        .
      </p>

      {/* Cookies */}
      <h2 className="text-xl font-semibold mb-2">
        Cookies
      </h2>

      <p className="text-white/80 mb-6">
        Cookies are small text files stored on your device that help improve
        website functionality, analyze site traffic, and enable advertising
        services. You can disable cookies through your browser settings,
        though some site features may not function properly.
      </p>

      {/* Updates */}
      <h2 className="text-xl font-semibold mb-2">
        Policy Updates
      </h2>

      <p className="text-white/80 mb-10">
        This Privacy Policy may be updated periodically. Any changes will be
        posted on this page.
      </p>
    </div>
  );
}
